var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"p-0"},[_c('divalto-codes-form',{on:{"save-code":_vm.handleSave,"toast-message":_vm.showToast}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }